import React from 'react'
import InnerImageZoom from 'react-inner-image-zoom'

import { Carousel } from '~/components'
import { cloudinary } from '~/utils'
import { transformations } from '~/utils/constants'

import 'react-inner-image-zoom/lib/InnerImageZoom/styles.css'

interface SliderProps {
  alt: string
  photos: string[]
}

const Slider = (props: SliderProps) => {
  const { alt, photos } = props

  const renderImage = (photo: string, index: number) => {
    return (
      <InnerImageZoom
        key={`product-image-${index}`}
        src={cloudinary.applyTransformations(photo, transformations.PRODUCT_SLIDER)}
        hideHint
        hideCloseButton
        imgAttributes={{ alt }}
        className={'inner-image-zoom-mobile'}
      />
    )
  }

  return <Carousel dataSource={photos} renderer={renderImage} />
}

export default Slider
